import { getPavedRoadsProjects } from "../api/pavedRoadsProjectsHttpClient";

export const usePavedRoadsProjectsGrid = () => {
  return { fetchGridData: getPavedRoadsProjects };
};
